import App from 'components/App/App'
import { createSelector } from 'reselect'

export function getOfferStatsKey(offerId: string, region: string) {
  return `${offerId}_${region}`
}

const getOfferStats = createSelector(
  (state: App.State) => state.recommendations.offerStats,
  (state: App.State, offerId: string) => getOfferStatsKey(offerId, state.geo.currentRegionCode),
  (allOfferStats, offerKey) => {
    const keyState = allOfferStats[offerKey]
    if (!!keyState && keyState.state === 'done') {
      return keyState.stats
    }
  },
)

export const getOfferValue = createSelector(
  (state: App.State, offerId: string) => getOfferStats(state, offerId),
  (offerStats?: App.RecommendationOfferStats) => {
    if (!!offerStats && offerStats.offerValue !== null) {
      return offerStats.offerValue
    }
  },
)
